import Image from 'next/image'
import { useSession } from 'next-auth/react'

import { useEffect, useState } from 'react'

import axios from 'axios'

import styles from './styles.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleMinus, faEye, faPencil, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

import { motion } from 'framer-motion'

import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner'
import { PulseLoader } from 'react-spinners'

import errorMsg from '../../../Functions/errorMsg'

import BusinessListing from '../BusinessListing/BusinessListing'
import EditBusiness from '../EditBusiness/EditBusiness';

export default function MyBusinesses({ setPendingRequest }) {

  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [businessListings, setBusinessListings] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(businessListings !== null) return;
    if(status === 'loading') return;
    if(!session) return;

    async function getMyListings() {
        setInitialLoading(true);
        setPendingRequest(true);

        const result = await axios.post(`${window.location.origin}/api/business/dashboard/getMyBusinesses`, {
          requestingUserID: session.user.token.id
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
            setPendingRequest(false);
        })

        if(result && result.status === 200) {
          const data = result.data;
          setBusinessListings(data);
          setPendingRequest(false);
        }

    }

    getMyListings();

  }, [session, status, initialLoading, businessListings])

  function isLoading() {
    if(status === 'loading') return true;
    if(initialLoading === false || initialLoading === null) return true;
    if(businessListings === null) return true;
    return false;
  }

  function refreshListings() {
    setBusinessListings(null);
    setInitialLoading(null);
  }

  const [viewListingData, setViewListingData] = useState(null);
  const [editListingData, setEditListingData] = useState(null);

  return (
    <section id={styles.wrapper}>
      { viewListingData !== null && <BusinessListing listingID={viewListingData} closeListing={() => setViewListingData(null)} /> }
      { editListingData !== null && <EditBusiness listingID={editListingData.listingID} isFixing={editListingData.isFixing} refreshListings={refreshListings} closeEditor={() => setEditListingData(null)}  /> }

      { isLoading() === true && <section id={styles.loading}><PulseLoader size={30} color='#154734' /></section> }

      { isLoading() === false && (businessListings.length === 0 ?
        <div id={styles.noListings}>
          <h1>You have no business listings</h1>
        </div>
        :
        <section id={styles.container}>
          {
            businessListings.map((listing, index) => {
              return <ListingCard key={index} listing={listing} setViewListingData={setViewListingData} setEditListingData={setEditListingData} />
            })
          }
        </section>
      )}

  </section>
  )
}

const ListingCard = ({ listing, setViewListingData, setEditListingData }) => {

  const listingID = listing._id;

  const [coverLoaded, setCoverLoaded] = useState(false);
  const getCover = listing.images.findIndex((images) => images.position === 1);

  function getReviewType() {
    var type = null;
    var fixed = false;

    listing.verdicts.forEach((verdict, index) => {
      if(verdict.fixed === true) {
        fixed = true;
      }
      if(listing.verdicts.length === (index + 1)) {
        if(verdict.fixed === false) {
          fixed = false;
        }
      }
    })

    if(listing.approved === false) {
      if(listing.verdicts.length > 0) {
        if(fixed === true) {
          type = 'Pending Approval'
        } else {
          type = 'Action Required'
        }
      } else {
        type = 'Pending Approval'
      }
    }

    return type;
  }

  return (
    <div className={styles.card}>

      { getReviewType() === 'Action Required' && <span id={styles.attention}> <FontAwesomeIcon icon={faTriangleExclamation} id={styles.icon} /> <h1>Action Required</h1> </span> }
      { getReviewType() === 'Pending Approval' && <span id={styles.pending}> <FontAwesomeIcon icon={faCircleMinus} id={styles.icon} /> <h1>Pending Approval</h1> </span> }

     <section>
        <h1>{listing.category}</h1>
        <div style={{display: coverLoaded === false ? 'flex' : 'none'}}> <LoadingSpinner type="pulse" color="#154734" /></div>
        <Image sizes='auto auto' fill src={listing.images[getCover].url} alt={listing.images[getCover].url} onLoadingComplete={() => setCoverLoaded(true)} />
      </section>
      <section>
        <div>
          <h1>{listing.title}</h1>
        </div>

        <div>
          { getReviewType() !== 'Pending Approval' && <motion.button onClick={() => setEditListingData({ isFixing: getReviewType() === 'Action Required' ? true : false, listingID: listingID })}>
            Edit<FontAwesomeIcon icon={faPencil} id={styles.icon} />
          </motion.button> }
          { getReviewType() === null && <motion.button onClick={() => setViewListingData(listingID)}><FontAwesomeIcon icon={faEye} id={styles.icon} /></motion.button> }
        </div>

      </section>
    </div>
  )
}